<template>
  <div class="topbar">
    <router-link class="btn btn--main" :to="{ name: 'add-account' }">{{ $t('top_bar.add_new_account') }}</router-link>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/accounts/Topbar.vue